import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes, OrderStatus, ProductLine, ROType } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useConfirmRetailOrder } from "../api/confirm-retail-order";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function ConfirmButton() {

	const navigate = useNavigate();
	const location = useLocation();
	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const confirmRetailOrder = useConfirmRetailOrder(order.details.retailOrderID,
		(result) => {
			showSuccessMessage('Retail order has been confirmed');
			refetchOrder()
				.then(() => {
					const newActionRequiredID = result.activeARs.find((x) => ![130, 140, 150].includes(x));

					const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
						(!!returnUrl ? '?returnUrl=' + returnUrl : '');

					if (newActionRequiredID && location.pathname !== to) {
						navigate(to);
					}
				})

		},
		(error) => showErrorMessage(error));

		return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-confirm' }}
				text="Confirm"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.CfiToConfirmOrChangeOrder) &&
					(!order.details.IME || order.details.roTypeID === ROType.Plumbing) &&
					order.details.roTypeID !== ROType.CabinetMeasureOrder}
				disabled={order.details.orderStatusID === OrderStatus.Pending || confirmRetailOrder.isLoading}
				onClick={() => {
					confirmRetailOrder.mutate();
				}} >
			</Button>
			<LoadPagePanel visible={confirmRetailOrder.isLoading}></LoadPagePanel>
		</>
	)
}
